<template lang="pug">
  div
    .panel.mx-auto.body-1.my-3.py-0
      .panel-page-white
        .user-page
          div
             .col.text-right
                router-link.btn.btn-primary.px-4(:to="{name: formItem('user_search_view','user_search_custom_back_button')}") Back to Search Results
          h1 View User
          AccountSection.mt-4(message="PERSONAL INFORMATION")
            .row
              .col
                div
                  strong User Name:
                  |  {{ user.username }}
                div.mt-1
                  strong First Name:
                  |  {{ user.firstName }}
                div.mt-1
                  strong Middle Name:
                  |  {{ user.middleName }}
                div.mt-1
                  strong Last Name:
                  |  {{ user.lastName }}
                div.mt-1
                  strong Title:
                  |  {{ user.title }}
                div.mt-1
                  strong Primary Email Address:
                  |  {{ user.email }}
                div.mt-1
                  strong Additional Email:
                  |  {{ user.altEmail1 }}
                div.mt-1
                  strong Additional Email:
                  |  {{ user.altEmail2 }}
                div.mt-1
                  strong Work Phone:
                  |  {{ user.workPhone }}
                div.mt-1
                  strong Supervisor's First Name:
                  |  {{ user.supervisorFirstName}}
                div.mt-1
                  strong Supervisor's Middle Name:
                  |  {{ user.supervisorMiddleName}}
                div.mt-1
                  strong Supervisor's Last Name:
                  |  {{ user.supervisorLastName}}
                div.mt-1
                  strong Supervisor's Rank:
                  |  {{ user.supervisorRank}}
                div.mt-1
                  strong Supervisor's Email:
                  |  {{ user.supervisorEmail}}
                div.mt-1
                  strong Supervisor's Phone:
                  |  {{ user.supervisorPhone}}
                div.mt-1
                  strong User Notes:
                  |  {{ user.notes }}
              .col.text-right
                router-link.btn.btn-primary.px-4(:to="{name: 'admin_edit_profile', query: {id: user.id}}") Edit
          AccountSection.mt-2(message="RESET PASSWORD")
            .row
              .col-8
                div
                  | Reset password sends a verification code to the account's primary email address
                  | and prompts the user to reset the password.
              .col.text-right
                button.btn.btn-primary.px-4(@click="resetPassword") Reset Password
          AccountSection.mt-2(message="STATUS & PERMISSIONS")
            .row
              .col
                div
                  strong Account Status:
                  |  {{ status }}
                div.mt-1
                  strong User Level:
                  |  {{ userLevel }}
                div.mt-1
                  strong User Role:
                  |  {{ user.sworn ? 'Sworn Personnel' : 'Non-Sworn Personnel' }}
                div.mt-1
                  strong U.S. Immigration and Customs Enforcement (ICE):
                  |  {{ user.iceAgent ? 'Yes' : 'No' }}
              .col-3.text-right
                router-link.btn.btn-primary.px-4(
                  :to="{name: 'admin_edit_status', query: {id: user.id}}"
                ) Edit
          AccountSection.mt-2(message="USER AGENCY")
            .row
              .col
                div
                  strong User Agency:
                  |  {{ agencies }}
              .col.text-right
                router-link.btn.btn-primary.px-4(:to="{name: 'admin_edit_agency', query: {id: user.id}}") Edit
          .row.mt-2
            .col
              strong Created By:
              |  {{ user.createdByName || 'Self-Registered' }}
            .col
              strong Last Updated By:
              |  {{ lastUpdatedBy }}
          .row
            .col
              strong Created On:
              |  {{ user.createdAt }}
            .col
              strong Last Updated On:
              |  {{ lastUpdateAt }}
    .account-history.mx-auto.mb-3.body-3
      h4(@click="historyExpanded = !historyExpanded")
        | Account Change History
        icon.caret(name="caret-up" scale="1.2" v-if="historyExpanded")
        icon.caret(name="caret-down" scale="1.2" v-if="!historyExpanded")
      Datatable(
        v-show="historyExpanded"
        :columns="columns"
        :per-page="15"
        :entries="accountHistory || []"
      )
        template(slot-scope="props")
          tr
            td {{ props.entry.adminName }}
            td {{ props.entry.changedAt }}
            td {{ props.entry.field }}
            td {{ props.entry.oldValue }}
            td {{ props.entry.newValue }}
</template>

<script>
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/caret-up'
import { titleCase } from '@/lib/utils'
import { saveItem, formItem } from '@/lib/formstore'
import AccountSection from '@/components/AccountSection'
import axios from '@/lib/axios'
import Datatable from '@/components/Datatable'
import { format } from 'date-fns/esm'
import { globalSuccess, globalError } from '@/lib/utils'

export default {
  name: 'UserSearchView',
  data() {
    return {
      user: {},
      accountHistory: [],
      historyExpanded: true,
      columns: [
        'Changed By',
        'Changed At',
        'Field Name',
        'Changed From',
        'Changed To',
      ],
    }
  },
  methods: {
    formItem,
    formatDate(dt) {
      return format(dt, 'MM-DD-YYYY hh:mm a')
    },
    resetPassword() {
      axios()
        .post('/api/admin/reset_user_password', { id: this.user.id })
        .then(resp => globalSuccess(resp))
        .catch(err => globalError(err))
    },
  },
  computed: {
    status() {
      return titleCase(this.user.status)
    },
    userLevel() {
      return titleCase(this.user.userLevel)
    },
    agencies() {
      return (this.user.agencyNames || []).join(', ')
    },
    lastUpdatedBy() {
      return this.accountHistory.length > 0
        ? this.accountHistory[0].adminName
        : ''
    },
    lastUpdateAt() {
      const ah = this.accountHistory
      return ah.length > 0 ? ah[0].changedAt : ''
    },
  },
  mounted() {
    if (Object.values(this.user).length === 0) {
      axios()
        .get('/api/admin/view_user', { params: { id: this.$route.query.id } })
        .then(resp => (this.user = resp.data))
    }

    axios()
      .get('/api/admin/user_change_history', {
        params: { id: this.$route.query.id },
      })
      .then(resp => (this.accountHistory = resp.data))
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'user_usage_report') {
      saveItem(
        'user_search_view',
        'user_search_custom_back_button',
        'user_usage_report',
      )
    } else if (from.name === 'user_search_results') {
      saveItem(
        'user_search_view',
        'user_search_custom_back_button',
        'user_search_results',
      )
    }
    const id = to.query.id
    axios()
      .get('/api/admin/view_user', { params: { id } })
      .then(resp => {
        next(vm => (vm.user = resp.data))
        scrollTo(0, 0)
      })
      .catch(err => globalError(err))
  },
  components: {
    AccountSection,
    Datatable,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';

.user-page {
  padding-left: 3rem;
  padding-right: 3rem;
}

.account-history {
  width: 835px;
  h4 {
    color: $primary;
    padding: 2rem 3rem;
    border: 1px solid #d8d8d8;
    cursor: pointer;
    user-select: none;
    margin-bottom: 0;

    .caret {
      margin-left: 1rem;
    }
  }
}
</style>
